var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.25C7.41304 1.25 8.04893 1.51339 8.51777 1.98223C8.98661 2.45107 9.25 3.08696 9.25 3.75V8.75H4.25V3.75C4.25 3.08696 4.51339 2.45107 4.98223 1.98223C5.45107 1.51339 6.08696 1.25 6.75 1.25ZM10.5 8.75V3.75C10.5 2.75544 10.1049 1.80161 9.40165 1.09835C8.69839 0.395088 7.74456 0 6.75 0C5.75544 0 4.80161 0.395088 4.09835 1.09835C3.39509 1.80161 3 2.75544 3 3.75V8.75C2.33696 8.75 1.70107 9.01339 1.23223 9.48223C0.763392 9.95107 0.5 10.587 0.5 11.25V17.5C0.5 18.163 0.763392 18.7989 1.23223 19.2678C1.70107 19.7366 2.33696 20 3 20H10.5C11.163 20 11.7989 19.7366 12.2678 19.2678C12.7366 18.7989 13 18.163 13 17.5V11.25C13 10.587 12.7366 9.95107 12.2678 9.48223C11.7989 9.01339 11.163 8.75 10.5 8.75ZM3 10H10.5C10.8315 10 11.1495 10.1317 11.3839 10.3661C11.6183 10.6005 11.75 10.9185 11.75 11.25V17.5C11.75 17.8315 11.6183 18.1495 11.3839 18.3839C11.1495 18.6183 10.8315 18.75 10.5 18.75H3C2.66848 18.75 2.35054 18.6183 2.11612 18.3839C1.8817 18.1495 1.75 17.8315 1.75 17.5V11.25C1.75 10.9185 1.8817 10.6005 2.11612 10.3661C2.35054 10.1317 2.66848 10 3 10Z",
    fill: "#8A68C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.42b32d2db3c08f2bff24b0556eef0ca2.svg";
export { ForwardRef as ReactComponent };